import firebaseService from '../../../firebase/firebaseService';
import useKlydoMutation, {
  UseKlydoMutationOptions,
} from '../../../hooks/useKlydoMutation';

const usePlayKlydoOnClockMutation = (
  options?: UseKlydoMutationOptions<
    string | null,
    { clockId: string; klydoId: string; clockVersion: number | undefined }
  >,
) => {
  return useKlydoMutation({
    mutationKey: ['play-klydo-on-clock'],
    mutationFn: ({ clockId, klydoId, clockVersion }) =>
      firebaseService.previewKlydoOnClock(clockId, klydoId, clockVersion),
    ...options,
  });
};

export default usePlayKlydoOnClockMutation;
